import clsx from 'clsx';
import React, { useMemo } from 'react';

import useWindowSize from '@hooks/useWindowSize';
import { Member, TeamGroupProps } from '@utils/aboutInterfaces';
import { WIDTH_SM } from '@utils/constants';

import Employee from './Employee';

const Group = ({ canSendMessage, group, setMessageUser }: TeamGroupProps) => {
  const { width } = useWindowSize();
  const twoColumns: Member[][] = useMemo(() => {
    const columns = [[], []];
    group.members.forEach((member, idx) => {
      columns[idx % 2].push(member);
    });
    return columns;
  }, [group.members]);

  return (
    <div className="border-0 border-b border-solid border-grayscale-beige py-48">
      <div className="m-auto inline-flex w-full flex-wrap items-start justify-between gap-x-90 sm:flex-nowrap md:gap-x-96 lg:gap-x-[160px]">
        <div className="flex w-full flex-col sm:w-[348px] md:w-[424px]">
          {twoColumns[0].map((member, idx) => (
            <Employee
              key={idx}
              member={member}
              onMessage={() => setMessageUser({ id: member.userId, name: member.name })}
              canSendMessage={canSendMessage}
              className={clsx({
                '!border-b-0': idx === twoColumns[0].length - 1 && WIDTH_SM <= width,
              })}
            />
          ))}
        </div>
        <div className="flex  w-full flex-col sm:w-[348px] md:w-[424px]">
          {twoColumns[1].map((member, idx) => (
            <Employee
              key={idx}
              member={member}
              onMessage={() => setMessageUser({ id: member.userId, name: member.name })}
              canSendMessage={canSendMessage}
              className={clsx({
                '!border-b-0': idx === twoColumns[1].length - 1,
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Group;
